import { Component, OnInit } from '@angular/core';
import { MainService } from '../../services/main.service';

@Component({
  selector: 'app-training-imgs',
  templateUrl: './training-imgs.component.html',
  styleUrls: ['./training-imgs.component.scss']
})
export class TrainingImgsComponent implements OnInit {

  pageData: any = {};

  constructor(private api: MainService) { }

  loadData() {

    this.api.getMediaTrainList().subscribe(
      data => {
        //debugger
        console.log(data);
        this.pageData = data;
      }, error => {
        console.log(error);
      });
  }
  ngOnInit() {

    this.loadData();
    window.scrollTo(0, 0);
  }

}
